module.exports = __webpack_public_path__ + "static/media/Rectangle 235.3d8af228.png";